exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".actions__btn--confirm{color:green !important}", "", {"version":3,"sources":["/home/webuser/yokohama/releases/50/spa/src/pages/sales/actions/Actions.scss"],"names":[],"mappings":"AAEI,uBACE,sBAAA,CAAA","file":"Actions.scss?vue&type=style&index=0&lang=scss&","sourcesContent":[".actions {\n  &__btn {\n    &--confirm {\n      color: green!important;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports
